import { __awaiter } from "tslib";
/**
 * 发起争议处理
 */
import { createStore } from '@souche-f2e/muji';
import { notification } from 'antd';
import { setKey } from '@/shared/functions';
import API from '@/services';
import React from 'react';
const resetData = {
    tableRowkey: '',
    tableData: [],
    tableColumn: [],
    pageIndex: 0,
    pageSize: 10,
    total: 0,
    pageIndexAuction: 0,
    totalAuction: 0,
    visible: false,
    params: null,
    title: '',
    activeTab: '1',
    loading: false,
    offerAuctionMode: null,
    offerSessionMsg: {},
};
const changeTitle = (title) => {
    return (<div>
      {title}
      <span style={{ color: '#ff0000', marginLeft: '8px' }}>注：{title}中不包含车易拍用户</span>
    </div>);
};
export default createStore({
    state: Object.assign({ tableKeyList: {
            offer: 'key',
            auction: 'id',
            brokerage: 'id',
            commission: 'id',
            playRules: 'id',
        }, type: '', titleList: {
            offer: '出价记录',
            offerSuper: '出价记录',
            brokerage: '修改记录',
            auction: '流拍记录',
            commission: '修改记录',
            playRules: '修改记录',
            focus: changeTitle('关注记录'),
            browse: changeTitle('浏览记录'),
        } }, resetData),
    effects: {
        updateData({ index, size }, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { type, id, pageSize } = state;
                this.SET_STATE({
                    loading: true,
                });
                switch (type) {
                    case 'brokerage':
                        this.editBrokerageUpdate({
                            pageIndex: index,
                            pageSize: size || pageSize,
                            id,
                        });
                        break;
                    case 'commission':
                        this.editCommissionUpdate({
                            pageIndex: index,
                            pageSize: size || pageSize,
                            id,
                        });
                        break;
                    case 'auction':
                        this.auctionUpdate({
                            index,
                            pageSize: size || pageSize,
                            goodsId: id,
                        });
                        break;
                    case 'playRules':
                        this.editPlayRulesUpdate({
                            pageIndex: index,
                            pageSize: size || pageSize,
                            id,
                        });
                        break;
                    case 'offer':
                        yield this.getAuctionType(id);
                        this.getOffer({
                            pageIndex: index,
                            pageSize: size || pageSize,
                            id,
                            isHidden: 0,
                        });
                        break;
                    case 'focus':
                        this.getFocusList({
                            pageIndex: index,
                            pageSize: size || pageSize,
                            id,
                            platformId: '',
                            type: 2,
                        });
                        break;
                    case 'browse':
                        this.getBrowseList({
                            auctionId: id,
                            pageIndex: index,
                            pageSize: size || pageSize,
                        });
                }
            });
        },
        getOffer(params, { state }) {
            const { pageIndex, pageSize, id } = params;
            const { offerAuctionMode } = state;
            switch (offerAuctionMode) {
                case 1011:
                case 1021:
                    this.offerSuperUpdate({
                        pageIndex,
                        pageSize,
                        auctionId: id,
                    });
                    break;
                default:
                    this.offerUpdate({
                        pageIndex,
                        pageSize,
                        auctionId: id,
                        type: 0,
                    });
            }
        },
        getAuctionType(auctionId) {
            return __awaiter(this, void 0, void 0, function* () {
                yield API.auction.getAuctionBaseInfo({
                    auctionId,
                })
                    .then((res) => {
                    const { auctionMode } = res;
                    this.SET_STATE({
                        offerAuctionMode: auctionMode,
                        offerSessionMsg: res,
                    });
                });
            });
        },
        editBrokerageUpdate(params, { state }) {
            this.SET_STATE({
                loading: true,
            });
            // 佣金
            API.auction.getBrokerageRecordPage(Object.assign({}, params))
                .then((res) => {
                if (res && res.items.length > 0) {
                    this.SET_STATE({
                        tableData: res.items || [],
                        pageIndex: res.currentIndex,
                        total: res.totalNumber,
                        visible: true,
                    });
                }
                else {
                    notification.warning({ message: '暂无修改记录' });
                }
            })
                .finally(() => {
                this.SET_STATE({
                    loading: false,
                });
            });
        },
        editCommissionUpdate(params, { state }) {
            // 服务费
            this.SET_STATE({
                loading: true,
            });
            API.auction.getCommissionRecordPage(Object.assign({}, params))
                .then((res) => {
                if (res && res.items.length > 0) {
                    this.SET_STATE({
                        tableData: res.items || [],
                        pageIndex: res.currentIndex,
                        total: res.totalNumber,
                        visible: true,
                    });
                }
                else {
                    notification.warning({ message: '暂无修改记录' });
                }
            })
                .finally(() => {
                this.SET_STATE({
                    loading: false,
                });
            });
        },
        // 玩法规则
        editPlayRulesUpdate(params, { state }) {
            this.SET_STATE({
                loading: true,
            });
            API.auction.getPlayRulesRecordPage(Object.assign({}, params))
                .then((res) => {
                if (res && res.items.length > 0) {
                    this.SET_STATE({
                        tableData: res.items || [],
                        pageIndex: res.currentIndex,
                        total: res.totalNumber,
                        visible: true,
                    });
                }
                else {
                    notification.warning({ message: '暂无修改记录' });
                }
            })
                .finally(() => {
                this.SET_STATE({
                    loading: false,
                });
            });
        },
        offerUpdate(params, { state }) {
            const { activeTab } = state;
            API.auction.bidRecord(Object.assign(Object.assign({}, params), { isHidden: 0 }))
                .then((res) => {
                if (activeTab === '2') {
                    this.SET_STATE({
                        tableData: setKey(res.items || []),
                        pageIndexAuction: res.currentIndex,
                        totalAuction: res.totalNumber,
                        visible: true,
                    });
                }
                else {
                    this.SET_STATE({
                        tableData: setKey(res.items || []),
                        pageIndex: res.currentIndex,
                        total: res.totalNumber,
                        visible: true,
                    });
                }
            })
                .catch(() => {
                notification.error({
                    message: '出价记录请求失败，请重试！',
                });
            })
                .finally(() => {
                this.SET_STATE({
                    loading: false,
                });
            });
        },
        offerSuperUpdate(params, { state }) {
            this.offerUpdate(Object.assign(Object.assign({}, params), { type: state.activeTab, isHidden: 0 }));
        },
        auctionUpdate(params, { state }) {
            API.goods.queryCarLossListByGoodsId(Object.assign({}, params))
                .then((res) => {
                this.SET_STATE({
                    tableData: res || [],
                    visible: true,
                });
            })
                .finally(() => {
                this.SET_STATE({
                    loading: false,
                });
            });
        },
        getFocusList(params) {
            API.auction.queryFocusPage(Object.assign({}, params))
                .then((res) => {
                this.SET_STATE({
                    tableData: res.items || [],
                    pageIndex: res.currentIndex,
                    total: res.totalNumber,
                    visible: true,
                });
            })
                .finally(() => {
                this.SET_STATE({
                    loading: false,
                });
            });
        },
        getBrowseList(params) {
            API.auction.queryBrowerPage(Object.assign({}, params))
                .then((res) => {
                this.SET_STATE({
                    tableData: res.items || [],
                    pageIndex: res.currentIndex,
                    total: res.totalNumber,
                    visible: true,
                });
            })
                .finally(() => {
                this.SET_STATE({
                    loading: false,
                });
            });
        },
        show({ id, type }, { state }) {
            this.SET_STATE({
                id,
                type,
                title: state.titleList[type],
                tableRowkey: state.tableKeyList[type],
            });
            this.updateData({ index: 1 });
        },
        hide() {
            this.SET_STATE({
                visible: false,
            });
        },
        changeTab(activeKey) {
            this.SET_STATE({
                activeTab: activeKey,
            });
            this.updateData({ index: 1 });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        hide(state) {
            state.visible = false;
            state.params = null;
        },
        resetState(state) {
            Object.keys(resetData).forEach((key) => {
                state[key] = resetData[key];
            });
        },
    },
});
